import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { FIELD__list_image_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_image_asset';
import { G_IMAGE__master_component } from '../_views/G_IMAGE__master_component';
import { G_IMAGE__view_no_image } from '../_views/G_IMAGE__view_no_image';
import { G_GRAPH__BUTTON__list_images_clear } from './_buttons/G_GRAPH__BUTTON__list_images_clear';
import { G_GRAPH__BUTTON__list_images_download } from './_buttons/G_GRAPH__BUTTON__list_images_download';
import { G_GRAPH__BUTTON__list_images_upload } from './_buttons/G_GRAPH__BUTTON__list_images_upload';
import { G_GRAPH__BUTTON__list_images_view_in_fullscreen } from './_buttons/G_GRAPH__BUTTON__list_images_view_in_fullscreen';
import { G_GRAPH__DRAG_AND_DROP__list_images_external } from './_drag_and_drop/G_GRAPH__DRAG_AND_DROP__list_images_external';
import { G_GRAPH__DRAG_AND_DROP__list_images_internal } from './_drag_and_drop/G_GRAPH__DRAG_AND_DROP__list_images_internal';
import { G_IMAGE_LIST__view_upload } from './G_IMAGE_LIST__view_upload';

const { GRID_CELL_SIZE, GRAPH_FIELD_HEIGHT_IMAGE } = CONSTANTS__shared;

interface PROPS {
  field: FIELD__list_image_asset;
}

export function G_GRAPH__FIELD__list_image_asset({ field }: PROPS) {
  let IMAGE_AREA_HEIGHT = GRID_CELL_SIZE * GRAPH_FIELD_HEIGHT_IMAGE;

  /*
   * RENDERS
   */

  function render_images() {
    if (field.meta.data__is_linked) return <G_IMAGE__view_no_image {...{ field }} text={'Data is Linked'} />;

    let items_views = field.items.map(item => {
      return (
        <G_IMAGE__master_component key={item.meta.field_id} {...{ field: item }} class_name_container="h-full w-[20%] max-w-[20%]"></G_IMAGE__master_component>
      );
    });

    let out = (
      <div className="size-full flex items-start justify-start overflow-hidden">
        {items_views}
        <G_IMAGE_LIST__view_upload {...{ field }} />
      </div>
    );

    return out;
  }

  /*
   * HTML
   */

  return (
    <div className="flex flex-row w-full" style={{ height: `${IMAGE_AREA_HEIGHT}px` }}>
      <div className="flex flex-col items-center justify-start" style={{ width: `${GRID_CELL_SIZE}px`, height: `${IMAGE_AREA_HEIGHT}px` }}>
        {/* todo: implement */}
        <G_GRAPH__BUTTON__list_images_upload {...{ field }} />
        <G_GRAPH__BUTTON__list_images_clear {...{ field }} />
        <G_GRAPH__BUTTON__list_images_download {...{ field }} />
        <G_GRAPH__BUTTON__list_images_view_in_fullscreen {...{ field }} />
      </div>

      <div className="relative flex-1" style={{ height: `${IMAGE_AREA_HEIGHT}px` }}>
        {render_images()}

        <G_GRAPH__DRAG_AND_DROP__list_images_external {...{ field }} />
        <G_GRAPH__DRAG_AND_DROP__list_images_internal {...{ field }} />
      </div>
      <div className="flex flex-col justify-start" style={{ width: `${GRID_CELL_SIZE}px`, height: `${IMAGE_AREA_HEIGHT}px` }}></div>
    </div>
  );
}
